import { AI_SERVICE } from "../content";
import { AiSectionHead } from "./AiSection";

/** 服务保障：深色板块，6 项服务。对应设计稿第 9 节。 */
export default function AiService() {
  return (
    <section aria-labelledby="ai-service-h" className="py-14 lg:py-20">
      <div className="rounded-3xl bg-[#060e1e] text-white/80 px-6 lg:px-10 py-12 lg:py-16">
        <AiSectionHead eyebrow={AI_SERVICE.eyebrow} title={AI_SERVICE.title} sub={AI_SERVICE.sub} onDark />
        <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {AI_SERVICE.items.map((s) => (
            <div key={s.title} className="p-6 rounded-2xl bg-white/5 border border-white/12">
              <span className="w-[42px] h-[42px] rounded-[10px] grid place-items-center text-lg bg-[#1a56db]/30 text-[#4db8ff] mb-4">
                <i className={s.icon}></i>
              </span>
              <h3 className="text-[15px] font-bold text-white mb-2">{s.title}</h3>
              <p className="m-0 text-sm text-white/70 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
